import { useState } from "react"
// import { Link } from "react-router-dom";
import { Button } from "@mui/material";


const Tables = () => {
    const [number, setNumber] = useState("");
    const [showTable, setShowTable] = useState(false);

    const generateTable = () => {
        setShowTable(true);
    };

    return (
        <div>
            <h2>
                <input type="number" placeholder="Enter a Number" value={number} onChange={(e) => setNumber(e.target.value)} />
                <Button variant="contained" onClick={generateTable}>Show</Button>
            </h2>

            <div>
                <h4>Tables with: {number}</h4>
                {showTable && (
                    <div>
                        {number} x 1 = {number * 1}<br />
                        {number} x 2 = {number * 2}<br />
                        {number} x 3 = {number * 3}<br />
                        {number} x 4 = {number * 4}<br />
                        {number} x 5 = {number * 5}<br />
                        {number} x 6 = {number * 6}<br />
                        {number} x 7 = {number * 7}<br />
                        {number} x 8 = {number * 8}<br />
                        {number} x 9 = {number * 9}<br />
                        {number} x 10 = {number * 10}<br />
                    </div>
                )}
            </div>
        </div>

    )
}

export default Tables;